import { rolldownPlugin } from './index.ts';

export default rolldownPlugin;
